var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card-actions',[_c('v-card-title',{staticClass:"text_box"},_vm._l((_vm.getProjectRoles),function(role){return _c('div',{key:role.id},[_c('v-chip',{attrs:{"color":"success","close":""},on:{"click:close":function($event){return _vm.deleteRole(role)}}},[_vm._v(" "+_vm._s(role.role_name)+" ")])],1)}),0)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }